import React from 'react';

import DocumentationHSMS from './hsms/DocumentationHSMS';

export default function Documentation({ match, isAuth, authComplete, schoolInfoLoading, userInfo, schoolType, setLoadScreen }) {
	const scrollToInstructions = (elementId) => {
		const targetElement = document.getElementById(elementId);

		// Check if the element exists before attempting to scroll
		if (targetElement) {
			// Scroll to the element with a smooth animation
			targetElement.scrollIntoView({
				behavior: 'smooth',
				block: 'start' // Aligns the top of the element with the top of the viewport (default)
			});
		}
	}
	return (
		<>
			{(() => {
				switch(schoolType) {
					case 'hsms':
						return <DocumentationHSMS match={match} isAuth={isAuth} authComplete={authComplete} schoolInfoLoading={schoolInfoLoading} userInfo={userInfo} schoolType={schoolType} setLoadScreen={setLoadScreen} scrollToInstructions={scrollToInstructions}/>;
					case 'elementary':
						return <DocumentationHSMS match={match} isAuth={isAuth} authComplete={authComplete} schoolInfoLoading={schoolInfoLoading} userInfo={userInfo} schoolType={schoolType} setLoadScreen={setLoadScreen} scrollToInstructions={scrollToInstructions}/>;
					default:
						return null;
				}
			})()}
		</>
	);
}